import { Stack, Skeleton } from '@mui/material'

export const RECENT_USER_ITEM_HEIGHT = 96

export function RecentUserItemSkeleton() {
  return (
    <Stack
      sx={{
        height: RECENT_USER_ITEM_HEIGHT,
        width: '82px',
        alignItems: 'center',
        padding: '10px 0 5px',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
      }}
    >
      <Skeleton variant="circular" width={56} height={56} />
      <Skeleton variant="text" width="30px" />
    </Stack>
  )
}
